import { apiRequest } from './http-client';
import type {
  FinPassPatientPayload,
  FinPassPatientResponse,
  PatientInsurancePayload,
  VobWebformSubmitPayload,
} from './types';

export async function createPatient(
  apiBase: string,
  authToken: string,
  payload: FinPassPatientPayload
): Promise<FinPassPatientResponse> {
  const response = await apiRequest<FinPassPatientResponse>(
    apiBase,
    '/patient/v2/patient',
    { method: 'POST', body: payload, authToken }
  );

  if (response.hasErrors || !response.entity?.patientId) {
    throw new Error(response.errorMessage ?? 'Failed to create patient record');
  }

  return response.entity;
}

export async function savePatientInsurance(
  apiBase: string,
  authToken: string,
  patientId: number,
  insurance: PatientInsurancePayload
): Promise<void> {
  const response = await apiRequest(
    apiBase,
    `/patient/v2/patient/${patientId}/insurance`,
    { method: 'POST', body: insurance, authToken }
  );

  if (response.hasErrors) {
    throw new Error(
      response.errorMessage ?? 'Failed to save patient insurance'
    );
  }
}

export function buildPatientPayload(
  form: VobWebformSubmitPayload,
  clientId: number
): FinPassPatientPayload {
  return {
    contact: {
      firstName: form.first_name?.trim() ?? '',
      lastName: form.last_name?.trim() ?? '',
      birthDate: new Date(form.date_of_birth ?? '').toISOString(),
      email: form.email?.trim() || undefined,
      primPhoneNum: form.phone?.trim() || undefined,
      primPhoneType: 'Home',
      primaryAddress: { addressType: 'Primary' },
      contactIncome: {
        isEmployed: false,
        yearlySalary: 0,
        employer: '',
        yearsAtEmployer: 0,
      },
    },
    patientStatus: 'NEW',
    clientId: String(clientId),
  };
}
